<template>
  <section>
    <Toolbar />
    <div
      class="
        d-flex
        flex-column
        justify-center
        align-center
        mt-6 mt-xs-3 mt-sm-3 mt-md-3 mt-lg-3 mt-xl-3
        mx-5
      "
    >
      <IconoHeader icono="close-circle-outline" />
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-6 mt-xs-3 mt-sm-3 mt-md-3 mt-lg-3 mt-xl-3"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <h2 class="texto-titulo text-center font-weight-bold">
            Por el momento<br />
            <span class="error--text">no fue posible continuar</span>
          </h2>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-6 mt-xs-3 mt-sm-3 mt-md-3 mt-lg-3 mt-xl-3"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <p
            class="
              text-body-1 text-center
              grey--text
              text--darken-2
              ma-0
              rechazo-texto
            "
          >
            Tu solicitud no pudo completarse en este momento. Puedes intentarlo
            nuevamente más adelante.
          </p>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-4 mt-xs-3 mt-sm-3 mt-md-3 mt-lg-3 mt-xl-3"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <p
            class="
              text-body-1 text-center
              grey--text
              text--darken-2
              ma-0
              rechazo-texto
            "
          >
            Te recomendamos acercarte a tu sucursal más cercana, donde podrán
            revisar si tienes algún otro crédito disponible para ti.
          </p>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-6">
        <v-col cols="12" class="ma-0 pa-0 d-flex justify-center">
          <img
            :src="imagenRechazo"
            alt="No fue posible continuar con tu solicitud"
            class="rechazo-imagen"
          />
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import IconoHeader from '@/components/compartidos/IconoHeader.vue'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'
import imagenRechazo from '@/assets/images/rechazoCD.svg'

export default {
  name: 'RechazoSolicitud',
  components: { Toolbar, IconoHeader },
  mixins: [InsertaLogMixin],
  data: () => ({
    imagenRechazo,
  }),
  mounted() {
    this.InsertaLog()
  },
}
</script>

<style scoped>
.rechazo-imagen {
  width: 260px;
  max-width: 100%;
  height: auto;
}

@media (max-width: 600px) {
  .rechazo-texto {
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
